module.exports = __webpack_public_path__ + "static/siegel_ekomi-362bfa2acacdbe494aa926c09d35d32b.png";